module.exports = __webpack_public_path__ + "static/media/davinci.fe9922b4.png";